// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 29 hooks for backend/owners.

import { useBackend } from '../useBackend'

/** POST /api/owners/acceptOwnerInspectionFaults */
export function useAcceptOwnerInspectionFaults<T = any>() {
  return useBackend<T>('owners/acceptOwnerInspectionFaults')
}

/** POST /api/owners/applyOwnerAction */
export function useApplyOwnerAction<T = any>() {
  return useBackend<T>('owners/applyOwnerAction')
}

/** POST /api/owners/applyOwnerTransferAction */
export function useApplyOwnerTransferAction<T = any>() {
  return useBackend<T>('owners/applyOwnerTransferAction')
}

/** POST /api/owners/assessOwnerOffboarding */
export function useAssessOwnerOffboarding<T = any>() {
  return useBackend<T>('owners/assessOwnerOffboarding')
}

/** POST /api/owners/closeOwnerOffboarding */
export function useCloseOwnerOffboarding<T = any>() {
  return useBackend<T>('owners/closeOwnerOffboarding')
}

/** POST /api/owners/decideOwnerContract */
export function useDecideOwnerContract<T = any>() {
  return useBackend<T>('owners/decideOwnerContract')
}

/** POST /api/owners/fetchOwnerFormFiles */
export function useFetchOwnerFormFiles<T = any>() {
  return useBackend<T>('owners/fetchOwnerFormFiles')
}

/** POST /api/owners/getOwnerApplication */
export function useGetOwnerApplication<T = any>() {
  return useBackend<T>('owners/getOwnerApplication')
}

/** POST /api/owners/getOwnerBoard */
export function useGetOwnerBoard<T = any>() {
  return useBackend<T>('owners/getOwnerBoard')
}

/** POST /api/owners/getOwnerContracts */
export function useGetOwnerContracts<T = any>() {
  return useBackend<T>('owners/getOwnerContracts')
}

/** POST /api/owners/getOwnerDocumentLink */
export function useGetOwnerDocumentLink<T = any>() {
  return useBackend<T>('owners/getOwnerDocumentLink')
}

/** POST /api/owners/getOwnerDocuments */
export function useGetOwnerDocuments<T = any>() {
  return useBackend<T>('owners/getOwnerDocuments')
}

/** POST /api/owners/getOwnerInspectionChecklist */
export function useGetOwnerInspectionChecklist<T = any>() {
  return useBackend<T>('owners/getOwnerInspectionChecklist')
}

/** POST /api/owners/getOwnerOffboarding */
export function useGetOwnerOffboarding<T = any>() {
  return useBackend<T>('owners/getOwnerOffboarding')
}

/** POST /api/owners/getOwnerOffboardingLetter */
export function useGetOwnerOffboardingLetter<T = any>() {
  return useBackend<T>('owners/getOwnerOffboardingLetter')
}

/** POST /api/owners/getOwnerPipeline */
export function useGetOwnerPipeline<T = any>() {
  return useBackend<T>('owners/getOwnerPipeline')
}

/** POST /api/owners/getOwnerTransfers */
export function useGetOwnerTransfers<T = any>() {
  return useBackend<T>('owners/getOwnerTransfers')
}

/** POST /api/owners/openOwnerInspectionPhoto */
export function useOpenOwnerInspectionPhoto<T = any>() {
  return useBackend<T>('owners/openOwnerInspectionPhoto')
}

/** POST /api/owners/ownerMailIntake */
export function useOwnerMailIntake<T = any>() {
  return useBackend<T>('owners/ownerMailIntake')
}

/** POST /api/owners/readOwnerDocument */
export function useReadOwnerDocument<T = any>() {
  return useBackend<T>('owners/readOwnerDocument')
}

/** POST /api/owners/recordOwnerOffboardingInspection */
export function useRecordOwnerOffboardingInspection<T = any>() {
  return useBackend<T>('owners/recordOwnerOffboardingInspection')
}

/** POST /api/owners/recordOwnerOffboardingStep */
export function useRecordOwnerOffboardingStep<T = any>() {
  return useBackend<T>('owners/recordOwnerOffboardingStep')
}

/** POST /api/owners/reviewOwnerDocument */
export function useReviewOwnerDocument<T = any>() {
  return useBackend<T>('owners/reviewOwnerDocument')
}

/** POST /api/owners/signOwnerInspectionPhoto */
export function useSignOwnerInspectionPhoto<T = any>() {
  return useBackend<T>('owners/signOwnerInspectionPhoto')
}

/** POST /api/owners/startOwnerOffboarding */
export function useStartOwnerOffboarding<T = any>() {
  return useBackend<T>('owners/startOwnerOffboarding')
}

/** POST /api/owners/stopOwnerOffboarding */
export function useStopOwnerOffboarding<T = any>() {
  return useBackend<T>('owners/stopOwnerOffboarding')
}

/** POST /api/owners/transferSigning */
export function useTransferSigning<T = any>() {
  return useBackend<T>('owners/transferSigning')
}

/** POST /api/owners/updateOwner */
export function useUpdateOwner<T = any>() {
  return useBackend<T>('owners/updateOwner')
}

/** POST /api/owners/uploadOwnerDocument */
export function useUploadOwnerDocument<T = any>() {
  return useBackend<T>('owners/uploadOwnerDocument')
}
